export { default as get } from "lodash/get";
export { default as isEmpty } from "lodash/isEmpty";

export function map(residential: any, arg1: (item: any) => { label: any; value: any; }) {
  throw new Error("Function not implemented.");
}
